import React, { useEffect, useState } from "react";
import { useAvailability, urgencyShort } from "@/hooks/useAvailability";
import { useProgram } from "@/lib/programs";
import { czk } from "@/lib/price";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const availability = useAvailability();
  const { program } = useProgram();

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const reservation = document.getElementById("reservation");
      const rTop = reservation ? reservation.getBoundingClientRect().top + window.scrollY : Infinity;
      // Show after hero (>800px) and hide once user is at reservation
      setVisible(y > 800 && y < rTop - 200);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-0 inset-x-0 z-40 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-brand-accent text-black">
        <div className="max-w-[1400px] mx-auto px-4 lg:px-10 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <span className="inline-block w-2 h-2 bg-black rounded-full animate-pulse shrink-0" />
            <div className="min-w-0">
              <div className="font-display font-black text-sm lg:text-base truncate" data-testid="sticky-urgency">
                {urgencyShort(availability)}
              </div>
              <div className="hidden sm:block text-xs opacity-80">
                {program.title} {czk(program.price)} · ozveme se a potvrdíme termín
              </div>
            </div>
          </div>
          <a
            href="#reservation"
            data-testid="sticky-cta-button"
            className="bg-black text-brand-accent font-semibold px-4 lg:px-6 py-2.5 lg:py-3 hover:bg-brand-bg transition-all whitespace-nowrap text-sm"
          >
            Rezervovat →
          </a>
        </div>
      </div>
    </div>
  );
}
